export default __webpack_public_path__ + "static/media/electrips_immersed_in_sound.c1a9f574.png";